<template>
  <div class="page">
    <!-- 第一个 -->
    <div class="intro">
      <div class="intro-title">聚合云，构建智慧支付生态圈</div>
      <div class="intro-msg">
        从支付到基于场景的智慧商圈，从传统模式到开放的综合服务平台，<br />始终以服务实体为本，构建以数字化作为驱动、运营管理更智能、体验更人性化的新型智慧商圈新生态
      </div>
      <div>
        <el-button type="primary" class="intro-btn" @click="openModal"
          >查看详情</el-button
        >
      </div>
    </div>

    <!-- 第二个 -->
    <div class="second-content">
      <div class="second">
        <div>
          <div class="title">
            <span>产品特点优势</span>
          </div>
          <div class="li-title">
            <span>多年技术积累，运维有保障，技术更放心</span>
          </div>
          <div class="pro">
            <div class="item">
              <div class="top">
                <img src="@/assets/new/pay.png" alt="" />
                <span>移动支付</span>
              </div>
              <div class="foot">
                <span
                  >提供不需使用现金、支票或信用卡消费者仍可使用移动设备支付各项服务及实体商品的费用能力支持</span
                >
              </div>
            </div>
            <div class="item">
              <div class="top">
                <img src="@/assets/new/sale.png" alt="" />
                <span>数字营销</span>
              </div>
              <div class="foot">
                <span
                  >多样化活动营销，各种优惠券、积 分、红包等权益可以在收银处进行统一结算，促进了商户侧营销活动的开展</span
                >
              </div>
            </div>
            <div class="item">
              <div class="top">
                <img src="@/assets/new/equity.png" alt="" />
                <span>商户权益</span>
              </div>
              <div class="foot">
                <span
                  >客户信息安全切实保护信息主体合法权益，保障信息安全，防范客户信息泄露、丢失、毁损或者被滥用不得侵犯个人隐私和商业秘密</span
                >
              </div>
            </div>
            <div class="item">
              <div class="top">
                <img src="@/assets/new/financial.png" alt="" />
                <span>聚合金融</span>
              </div>
              <div class="foot">
                <span
                  >以聚合支付收单业务为切入点，通过技术分析运用数据模型筛选出适配客户群，深入挖掘实现经营价值，交叉营销，扩大价值最大化</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="third">
        <div>
          <!-- 小圆点 -->
          <ul class="circle-list">
            <li class="circle active" data-n="0">店收盈码牌</li>
            <li class="circle" data-n="1">店收盈云音箱</li>
            <li class="circle" data-n="2">客显屏音箱</li>
            <li class="circle" data-n="3">扫码盒</li>
            <li class="circle" data-n="4">智能pos</li>
            <li class="circle" data-n="5">定制云打印机</li>
          </ul>
          <!-- 图片列表 -->
          <div class="imgs">
            <div class="img-list">
              <img src="@/assets/new/product1.png" />
              <img src="@/assets/new/product2.png" />
              <img src="@/assets/new/product3.png" />
              <img src="@/assets/new/product4.png" />
              <img src="@/assets/new/product5.png" />
              <img src="@/assets/new/product6.png" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 第四个 -->
    <div class="four">
      <div>
        <div class="four-title">全面、专业、完善的服务体系和运营支持</div>
        <div class="four-content">
          <div class="four-item">
            <number-scroll :endVal="140"></number-scroll>
            <span>全国各地城市覆盖</span>
          </div>
          <div class="four-item">
            <number-scroll :endVal="2460"></number-scroll>
            <span>客户的本地化服务</span>
          </div>
          <div class="four-item">
            <number-scroll :endVal="120"></number-scroll>
            <span>本地头部品牌的联合服务</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 第五个 -->
    <div class="fifth">
      <div>
        <div class="title"><span>众多品牌的一致认可</span></div>
        <ul class="tag-list">
          <li class="tag active" data-i="0">服饰鞋帽</li>
          <li class="tag" data-i="1">数码家电</li>
          <li class="tag" data-i="2">食品饮料</li>
          <li class="tag" data-i="3">餐饮美食</li>
        </ul>
        <div class="imgs">
          <div class="fifth-img-list">
            <img src="@/assets/new/fifth1.png" />
            <img src="@/assets/new/fifth2.png" />
            <img src="@/assets/new/fifth3.png" />
            <img src="@/assets/new/fifth4.png" />
          </div>
        </div>
      </div>
    </div>
    <!-- 第六个 -->
    <div class="six">
      <div>
        <div class="six-title">聚合云动态</div>
        <div class="six-content">
          <div class="six-item">
            <img src="@/assets/new/dynamic1.png" alt="" srcset="" />
            <div>支付监管规则更新强化《非银行支付机构监 督管理条例》发布</div>
            <div>聚合云集团 2023-12-21 16:00 福建</div>
            <div class="viewmore" @click="goDetail(2)">了解详情></div>
          </div>
          <div class="six-item">
            <img src="@/assets/new/dynamic2.png" alt="" srcset="" />
            <div>中秋国庆支付数据发布：部分行业增长明显</div>
            <div>聚合云集团 2023-10-18 12:30 福建</div>
            <div class="viewmore" @click="goDetail(3)">了解详情></div>
          </div>
          <div class="six-item">
            <img src="@/assets/new/dynamic3.png" alt="" srcset="" />
            <div>探讨行业发展 | 支付要闻更新</div>
            <div>聚合云集团 2024-03-21 16:00 福建</div>
            <div class="viewmore" @click="goDetail(1)">了解详情></div>
          </div>
        </div>
        <div class="six-footer">
          <span @click="goList()">查看更多→</span>
        </div>
      </div>
    </div>
    <!-- 第七个 -->
    <div class="seven">
      <img src="@/assets/new/seven.png" alt="" srcset="" />
    </div>
    <Dialog ref="dialog"></Dialog>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import Slider from "./Slider";
import NumberScroll from "./NumberScroll.vue";
import Dialog from "./dialog";
export default {
  name: "Index",
  components: {
    Slider,
    Swiper,
    Dialog,
    "swiper-slide": SwiperSlide,
    "number-scroll": NumberScroll,
  },
  data() {
    return {
      tabIndex: 1,
      option: {
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        initialSlide: 0,
        spaceBetween: 16,
        on: {
          click: function () {
            realIndex = this.realIndex;
          },
        },
      },
    };
  },
  methods: {
    goDetail(i) {
      this.$router.push({ name: "NewsDetail" });
      localStorage.setItem("id", i);
    },
    goList() {
      this.$router.push({ name: "NewsList" });
    },
    openModal() {
      this.$refs.dialog.openLog();
    },
    checkmouse(e) {
      if (e) {
        this.tabIndex = e;
      }
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClick(e) {
      console.log(1111, e);
    },
    thirdbanner() {
      let oImgList = document.querySelector(".img-list");
      let clonefirstImg = oImgList.firstElementChild.cloneNode();
      oImgList.appendChild(clonefirstImg);
      let index = 0;
      const circles = document.querySelectorAll(".circle");
      function setCircles() {
        for (let i = 0; i < circles.length; i++) {
          if (i === index) {
            circles[i].classList.add("active");
          } else {
            circles[i].classList.remove("active");
          }
        }
      }
      const oCircle = document.querySelector(".circle-list");
      oCircle.addEventListener("mouseover", (e) => {
        if (e.target.nodeName.toLowerCase() === "li") {
          const n = Number(e.target.getAttribute("data-n"));
          index = n;
          setCircles();
          oImgList.style.transition = "0.5s ease";
          oImgList.style.left = -index * 100 + "%";
        }
      });
    },
    fifthbanner() {
      let oImgList = document.querySelector(".fifth-img-list");
      let clonefirstImg = oImgList.firstElementChild.cloneNode();
      oImgList.appendChild(clonefirstImg);
      let index = 0;
      const circles = document.querySelectorAll(".tag");
      function setCircles() {
        for (let i = 0; i < circles.length; i++) {
          if (i === index) {
            circles[i].classList.add("active");
          } else {
            circles[i].classList.remove("active");
          }
        }
      }
      const oCircle = document.querySelector(".tag-list");
      oCircle.addEventListener("mouseover", (e) => {
        if (e.target.nodeName.toLowerCase() === "li") {
          const n = Number(e.target.getAttribute("data-i"));
          index = n;
          setCircles();
          oImgList.style.transition = "0.5s ease";
          oImgList.style.left = -index * 100 + "%";
        }
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.thirdbanner();
      this.fifthbanner();
    });
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.page {
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  font-family: PingFang SC, PingFangSC-Medium;
  width: 100%;
  overflow-x: hidden;

  .intro {
    background: url(../assets/new/index_1.jpg) no-repeat center;
    background-size: cover;
    height: auto;
    min-height: 400px;
    color: white;
    padding: 30px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .intro-title {
    margin-top: 60px;
    margin-bottom: 20px;
    font-size: 28px;
  }
  .intro-msg {
    font-size: 16px;
    line-height: 1.6;
  }
  .intro-btn {
    margin-top: 30px;
    width: 140px;
    height: 48px;
    background: #fff;
    border: none;
    color: #de1f26;
    font-size: 14px;
  }

  .second-content {
    color: #262626;
    .second {
      background: url(../assets/new/second_bg.png) no-repeat center;
      background-size: cover;
      padding: 30px 20px;
      > div {
        max-width: 1200px;
        width: 100%;
        margin: 0 auto;
        text-align: center;
      }
      .title {
        font-size: 28px;
        padding-top: 20px;
      }
      .li-title {
        font-size: 16px;
        padding: 20px 0;
      }
      .pro {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 20px;
        .item {
          width: 100%;
          max-width: 280px;
          height: auto;
          min-height: 280px;
          background: #fff;
          padding: 20px;
          box-shadow: 0 0 35px rgba(187, 187, 187, 0.25);
          .top {
            display: flex;
            flex-direction: column;
            align-items: center;
            img {
              width: 54px;
              padding-top: 20px;
            }
            span {
              padding-top: 10px;
              color: #333;
              font-weight: bold;
            }
          }
          .foot {
            padding-top: 10px;
            color: #707172;
          }
        }
      }
    }
  }

  .third {
    height: auto;
    padding: 30px 20px;
    > div {
      max-width: 1200px;
      width: 100%;
      margin: 0 auto;
      position: relative;
    }
    .title {
      font-size: 28px;
      text-align: center;
    }
    .imgs {
      width: 100%;
      overflow: hidden;
    }
    .img-list {
      display: flex;
      position: relative;
      left: 0;
      transition: 0.5s ease;
    }
    .img-list img {
      width: 100%;
    }
    .circle-list {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 10px;
      border-bottom: 2px solid rgba(213, 24, 27, 0.3);
      font-size: 16px;
      padding-bottom: 10px;
    }
    @media (max-width: 767px) {
      .circle-list {
        display: flex;
        justify-content: flex-start;
      }
    }
    .circle {
      padding: 0 10px;
      white-space: nowrap;
    }
    .circle.active {
      border-bottom: 2px solid #de1f26;
    }
  }

  .four {
    background: url(../assets/new/four_bg.png) no-repeat center;
    background-size: cover;
    height: auto;
    padding: 50px 20px;
    > div {
      max-width: 1200px;
      margin: 0 auto;
    }
    .four-title {
      font-size: 28px;
      text-align: center;
    }
    .four-content {
      display: flex;
      flex-direction: column;
      gap: 40px;
      margin-top: 60px;
      align-items: center;
      .four-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        span:nth-of-type(1) {
          color: #de1f26;
          font-size: 36px;
        }
        span:nth-of-type(2) {
          color: #626562;
          font-size: 18px;
        }
      }
    }
  }

  .fifth {
    height: auto;
    padding: 30px 20px;
    > div {
      max-width: 1200px;
      width: 100%;
      margin: 0 auto;
    }
    .title {
      font-size: 28px;
      text-align: center;
    }
    .tag-list {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 15px;
      // gap: 30px;
      border-bottom: 2px solid #f8f8f8;
      font-size: 16px;
      padding-bottom: 10px;
      // @media (max-width: 767px) {
      //   .tag-list {
      //     display: flex;
      //     justify-content: flex-start;
      //   }
      // }
      .tag {
        padding: 0 5px;
        white-space: nowrap;
      }
      .active {
        border-bottom: 2px solid #de1f26;
      }
    }
    .imgs {
      padding-top: 30px;
      overflow: hidden;
    }
    .fifth-img-list {
      display: flex;
      position: relative;
      left: 0;
      transition: 0.5s ease;
      img {
        width: 100%;
      }
    }
  }

  .six {
    background-color: #f5f8ff;
    padding: 40px 20px;
    > div {
      max-width: 1200px;
      width: 100%;
      margin: 0 auto;
    }
    .six-title {
      font-size: 28px;
      text-align: center;
    }
    .six-content {
      display: flex;
      // flex-direction: column;
      justify-content:space-between;
      flex-wrap: wrap;
      gap: 20px;
      padding-top: 30px;
      .six-item {
        width: 100%;
        height: auto;
        background: #fff;
        border-radius: 8px;
        overflow: hidden;
        img {
          width: 100%;
          height: auto;
        }
        div {
          padding: 0 10px;
        }
        div:nth-of-type(1) {
          font-size: 18px;
          color: #262626;
        }
        div:nth-of-type(2) {
          font-size: 14px;
          color: #707172;
        }
        .viewmore {
          text-align: right;
          color: #de1f26;
          cursor: pointer;
          padding: 10px;
        }
      }
      @media (min-width: 992px) {
        .six-item {
          width:30%;
        }
      }
    }
    .six-footer {
      text-align: center;
      padding-top: 20px;
      span {
        background: #de1f26;
        color: #fff;
        padding: 10px 20px;
        display: inline-block;
      }
    }
  }

  .seven {
    width: 100%;
    img {
      width: 100%;
      height: auto;
    }
  }
}

@media (min-width: 768px) {
  .page {
    .intro {
      padding: 30px 100px;
      align-items: flex-start;
      text-align: left;
    }
    .intro-title {
      font-size: 38px;
    }
    .four-content {
      flex-direction: row;
      justify-content: space-around;
    }
    .six-content {
      flex-direction: row;
    }
  }
}
</style>
